
const databaseCategories = [
    'Behavioral Health',
    'Child Care',
    'Disaster Services',
    'Environment',
    'Environmental Education',
    'Disabilities',
    'Health Care',
    'Homelessness',
    'Juvenile Justice Community Programs',
    'Juvenile Justice Services',
    'Mental Health',
    'Military and Veterans Services',
    'Military Family Services',
    'Senior Programs and Services',
    'Substance Abuse',
];

// Node compatible for npm script use
module.exports = databaseCategories;


// WEBPACK FOOTER //
// ./src/data/db-categories.js